import { render } from "./NavbarPage.vue?vue&type=template&id=1bdd6990&scoped=true"
import script from "./NavbarPage.vue?vue&type=script&lang=js"
export * from "./NavbarPage.vue?vue&type=script&lang=js"

import "./NavbarPage.vue?vue&type=style&index=0&id=1bdd6990&scoped=true&lang=css"

import exportComponent from "/Users/salome/Desktop/salomeg5/bedoya_group/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bdd6990"]])

export default __exports__